import Loader from "react-loader-spinner";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useRef } from "react";
import { Alert, Button, Form, FormGroup, Modal, Row, Table } from "react-bootstrap";
import ModalSearchStorage from "../../../Components/Modals/ModalSearchStorage";
import ModalProducts from "../../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../../store/api/SystemSettingsAPI";
import { useDispatch, useSelector } from "react-redux";
import { CheckLg, DashCircle, List } from "react-bootstrap-icons";
import { getAllGuaranteeHolders, updateCardsProductAndInvoice } from "../../store/api/GuaranteeApi";

export default function ModalAssignProductToGuaranteeCards({ popData, setPopData }) {
    const settingNames = ['ProductGrouppingType'];
    const { systemSettings } = useSelector(state => ({
        systemSettings: state.SystemSettingsReducer.systemSettings
    }));
    const dispatch = useDispatch();
    const timeoutRef = useRef();
    const scrollRef = useRef(null); // ref برای div جدول

    const [serialList, setSerialList] = useState([]);
    const [holderList, setHolderList] = useState(null);
    const [startIndex, setStartIndex] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [hoverIndex, setHoverIndex] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [submitData, setSubmitData] = useState({});
    const [submitMessage, setSubmitMessage] = useState(null);
    const [pending, setPending] = useState(false);

    const pgType = Array.isArray(systemSettings ?? "") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;

    const close = () => {
        setSerialList(null);
        setPopData({ show: false });
        setSubmitData({});
    };

    const getUploadedFile = (e) => {
        if (pending) return;
        const file = e.currentTarget.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            let lines = text
                .split(/\r?\n/)
                .map(line => line.replaceAll(" ",""))
                .filter(line => line !== "");
            // برای حذف ردیفهای تکراری
            lines = [...new Set(lines)];
            const data = lines
                .sort()
                .map((l, i) => ({ SerialNumber: l, selected: false, indx: i }));
            setSerialList(data);
        };
        reader.readAsText(file);
    };

    const showModalStorage = (e) => {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) return;
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            setSubmitData({ ...submitData, StorageID: data?.StorageID, StorageName: data?.StorageName });
        }
        setPopStorage({ show: true, isStaffStorage: false, setStorageData: onSelectStorage });
    }

    const showModalProduct = () => {
        const onSetData = (data) => {
            if (data?.ProductID) {
                setSubmitData({
                    ...submitData,
                    ProductID: data.ProductID,
                    ProductCode: data.ProductCode,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel
                })
            }
        }
        setPopProduct({ show: true, setProductData: onSetData });
    }

    const handleMouseDown = (indx) => {
        setStartIndex(indx);
        setIsDragging(true);
    };

    const handleMouseUp = (indx) => {
        if (isDragging && startIndex !== null) {
            const from = Math.min(startIndex, indx);
            const to = Math.max(startIndex, indx);
            setSerialList(prev =>
                prev.map((item, i) =>
                    i >= from && i <= to ? { ...item, selected: !item.selected } : item
                )
            );
        }
        setStartIndex(null);
        setIsDragging(false);
        setHoverIndex(null);
    };

    const handleCheckboxClick = (indx) => {
        setSerialList(prev =>
            prev.map((item, i) =>
                i === indx ? { ...item, selected: !item.selected } : item
            )
        );
    };

    const toggleSelectAll = () => {
        const allSelected = serialList.every(s => s.selected);
        setSerialList(prev => prev.map(item => ({ ...item, selected: !allSelected })));
    };

    useEffect(() => {
        const handleMouseUp = () => setIsDragging(false);
        document.addEventListener("mouseup", handleMouseUp);
        return () => document.removeEventListener("mouseup", handleMouseUp);
    }, []);

    useEffect(() => {
        if (popData.show) {
            dispatch(getSystemSettings(settingNames));
            getAllGuaranteeHolders(null, setHolderList);
        }
    }, [popData.show]);

    // --- Auto Scroll هنگام Drag ---
    useEffect(() => {
        if (!isDragging) return;

        const handleMouseMove = (e) => {
            if (!scrollRef.current) return;
            const container = scrollRef.current;
            const rect = container.getBoundingClientRect();
            const scrollSpeed = 10;
            const edgeSize = 50;

            if (e.clientY > rect.bottom - edgeSize) container.scrollTop += scrollSpeed;
            else if (e.clientY < rect.top + edgeSize) container.scrollTop -= scrollSpeed;
        };

        document.addEventListener("mousemove", handleMouseMove);
        return () => document.removeEventListener("mousemove", handleMouseMove);
    }, [isDragging]);

    const handleSubmit = () => {
        if (pending) return;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        const onUpdate = (res) => {
            if (res.Error) {
                setSubmitMessage({ message: res.Error });
                setPending(false);
            } else if (res !== "PENDING") {
                setSubmitMessage({ message: "عملیات با موفقیت انجام شد", isSuccess: true });
                const remainedSerials = serialList.filter(s => !s.selected);
                setSerialList(remainedSerials);
                setPending(false);
            }
            timeoutRef.current = setTimeout(() => setSubmitMessage(null), 3000);
        }

        const data = { ...submitData, SerialNumbers: serialList.filter(s => s.selected).map(s => s.SerialNumber) };
        if (data.SerialNumbers.length < 1) {
            setSubmitMessage({ message: "سریالی انتخاب نشده است." });
            timeoutRef.current = setTimeout(() => setSubmitMessage(null), 3000);
            return;
        }

        setPending(true);
        updateCardsProductAndInvoice(data, onUpdate);
    }

    return (
        <Modal show={popData?.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice=""
                defaultSalePriceLabel="" defaultStorages="" hideNewProduct={true} />
            <Modal.Header className='headerStyle'>
                <span><FontAwesomeIcon icon={faCheckCircle} size='lg' /> &nbsp; اختصاص کالا به کارتهای گارانتی</span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                {submitMessage && <Alert variant={submitMessage.isSuccess ? "success" : "danger"}>{submitMessage.message}</Alert>}
                <FormGroup className="mt-0">
                    <label>فایل سریالها:</label>
                    <input className="form-control" type="file" accept=".txt" onChange={getUploadedFile} disabled={pending} placeholder="فایل سریال ها" />
                </FormGroup>

                {Array.isArray(serialList) && <>
                    <div ref={scrollRef} className="scThin mt-1" style={{ maxHeight: "310px", overflow: "auto", userSelect: "none" }}>
                        <Table className="mb-0">
                            <thead>
                                <tr style={{ top: 0, position: "sticky" }}>
                                    <th style={{ backgroundColor: "#bfbbbb", width: "1px" }}></th>
                                    <th style={{ width: "1px", backgroundColor: "#bfbbbb", cursor: "pointer" }} onClick={toggleSelectAll}>انتخاب</th>
                                    <th style={{ backgroundColor: "#bfbbbb" }}>شماره سریال</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serialList.map((serial, i) =>
                                    <tr key={i} className={`resultTableRow ${isDragging && startIndex !== null && hoverIndex !== null &&
                                        i >= Math.min(startIndex, hoverIndex) &&
                                        i <= Math.max(startIndex, hoverIndex) ? "selectedResultTableRow" : ""}`}
                                        onMouseDown={(e) => { if (e.target.tagName.toLowerCase() === "input") return; handleMouseDown(i); }}
                                        onMouseUp={() => handleMouseUp(i)}
                                        onMouseEnter={() => { if (isDragging) setHoverIndex(i); }}>
                                        <td>{i + 1}</td>
                                        <td>
                                            <input type="checkbox" className="form-check-input" checked={serial.selected}
                                                onChange={() => handleCheckboxClick(i)}
                                                onMouseDown={e => e.stopPropagation()} />
                                        </td>
                                        <td>{serial.SerialNumber}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <Row className="rowBorder p-1 mt-1">
                        <FormGroup className="col-md-6 mt-1">
                            <label>کالای اختصاصی:</label>
                            <input className="tableRowInput" value={(submitData.ProductName ?? "") + "-" + (submitData.ProductModel ?? "")} />
                            <Button className="btn-input-tiny" style={{ left: 6, top: 21 }} onClick={showModalProduct}><List size={18} /></Button>
                        </FormGroup>
                        <FormGroup className="col-md-6 mt-1">
                            <label>انبار ثبت رسید:</label>
                            <input className="tableRowInput" onKeyDown={showModalStorage} value={submitData.StorageName ?? ""} readOnly />
                            <Button className="btn-input-tiny" style={{ left: 6, top: 21 }} onClick={showModalStorage}><List size={18} /></Button>
                        </FormGroup>
                        <FormGroup className="col-md-6">
                            <label>نام برند: </label>
                            {Array.isArray(holderList ?? "") ?
                                <select className="tableRowInput" onChange={e => setSubmitData({ ...submitData, HolderID: e.target.value })}>
                                    <option value="">انتخاب کنید</option>
                                    {holderList.map((item, i) => <option key={i} value={item.ID}>{item.HolderName}</option>)}
                                </select> :
                                <div className="tableRowInput">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>}
                        </FormGroup>
                    </Row>

                    <Button variant="success" className="mt-1 group-Btn" onClick={handleSubmit} disabled={pending}><CheckLg size={18} /> ثبت اطلاعات</Button>
                    <Button variant="danger" className="mt-1 group-Btn" onClick={close} disabled={pending}><DashCircle size={18} /> انصراف</Button>
                </>}
            </Modal.Body>
        </Modal>
    );
}
